import { render, staticRenderFns } from "./Mailings.vue?vue&type=template&id=9b25bbba&"
import script from "./Mailings.vue?vue&type=script&lang=js&"
export * from "./Mailings.vue?vue&type=script&lang=js&"
import style0 from "./Mailings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports